<script>
import HeadTile from '../components/dashboard/tiles/HeadTile.vue'
import TailTile from '../components/dashboard/tiles/TailTile.vue'
import Voucher from '../components/credit/voucher/Voucher.vue'

export default {
  name: 'Dashboard',
  components: { HeadTile, TailTile, Voucher },
  computed: {
    title() {
      return this.$t('page.dashboard.view.header')
    }
  }
}
</script>
<template>
  <v-container id="dashboard" fluid>
    <Voucher />
    <HeadTile />
    <TailTile />
  </v-container>
</template>
<style lang="scss" scoped>
.tile {
  min-height: 400px;
}
</style>
